import { FC } from 'react'

import { ModalSectionProps, RotaPatternModalType } from '../utils'
import { SkillsRequired } from 'screens/Rostering/formComponents'
import useResidentsList from 'hooks/useResidentsList'
import useUserSkills from 'screens/Rostering/hooks/useUserSkills'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import { getNominative } from 'common/utils'

export const SkillsRequiredSection: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ formData, type }) => {
  const selectedResident = formData?.serviceUserPattern

  const { residents } = useResidentsList({})

  const foundResident = residents?.find(
    (resident) => resident?.id === selectedResident
  )

  const { allSkills } = useUserSkills()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )
  const residentNominative = getNominative(
    preferredPeopleNominative,
    'resident'
  )

  return (
    <SkillsRequired
      type={type}
      nameBasedOne={foundResident?.name?.first || residentNominative}
      skillOptions={[
        ...allSkills.map((skill) => ({ value: skill?.id, label: skill?.name })),
      ]}
      maxValue={formData?.numberSupply}
    />
  )
}
